import {
  registerRoutes,
  stores,
  history,
  onReady
} from 'mutants-microfx';

import Test1 from '../test';



import RefTree from '../../components/RefTree';
import RefPage from '../../components/RefPage';


//import RefInventory from '../inventory';
import RefPartner from '../partner';



registerRoutes([{
  path: '/component',
  component: Test1
}])

// registerRoutes([{
//   path: '/ref/inventory',
//   component: RefInventory,
//   cache: true
// }])
registerRoutes([{
  path: '/ref/partner',
  component: RefPartner
}])
registerRoutes([{
  path: '/ref/tree',
  component: RefTree
}])

registerRoutes([{
  path: '/ref/page',
  component: RefPage
}])